export enum EKeyStore {
  AccessToken = 'access_token',
  RememberMe = 'RememberMe',
  RefreshToken = 'refresh_token',
  Auth = 'auth',
  MyProfile = 'my-profile',
}

export class StoreUtils {
  public static get(key: EKeyStore): string | null {
    return localStorage.getItem(key);
  }

  public static getObj<T>(key: EKeyStore): T | null {
    const val = localStorage.getItem(key);

    if (!val) return null;

    return JSON.parse(val) as T;
  }

  public static set(key: EKeyStore, val: string) {
    localStorage.setItem(key, val);
  }

  public static setObj<T>(key: EKeyStore, val: T) {
    localStorage.setItem(key, JSON.stringify(val));
  }

  public static clear() {
    localStorage.clear();
  }

  public static remove(key: EKeyStore) {
    localStorage.removeItem(key);
  }
}
